import * as React from "react";
import { BalancesFragmentFragment } from "../../graphql/BalancesFragment.generated";
import { GameStatisticsFragmentFragment } from "../../graphql/GameStatisticsFragment.generated";
import { Versus } from "../Versus";
import { GameStatisticsCompare } from "./GameStatisticsCompare";
import { BalanceStatisticsCompare } from "./BalanceStatisticsCompare";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Row } from "./Row";
import trophyIcon from "../../assets/trophy.png";

type Balances = BalancesFragmentFragment["balances"];
type GameStatistics = GameStatisticsFragmentFragment["statistics"];
type Statistics = {
  balances: Balances;
  gaming: GameStatistics;
  name: string;
  experiencePoints?: number;
};

export const PlayerStatisticsCompare = ({
  me,
  other,
  games,
  tournament,
}: {
  me: Statistics | null;
  other: Statistics | null;
  games: Array<string>;
  tournament: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <>
      {me !== null && other !== null && (
        <div className="mb-4">
          <Versus nameA={me.name} nameB={other.name} />
        </div>
      )}
      <div
        className={classNames("bg-blue-900", "rounded", "mb-4", {
          "px-4 py-2": me === null || other === null,
        })}
      >
        <GameStatisticsCompare
          me={me?.gaming ?? null}
          other={other?.gaming ?? null}
          games={games}
          tournament={tournament}
        />
      </div>
      <div
        className={classNames("bg-blue-900", "rounded mb-4", {
          "px-4 py-2": me === null || other === null,
        })}
      >
        <div className="py-2 text-center text-lg font-bold">
          {t("balances")}
        </div>
        <BalanceStatisticsCompare
          other={other?.balances ?? null}
          me={me?.balances ?? null}
        />
      </div>
      {!me && other && (
        <div
          className={classNames("bg-blue-900", "rounded mb-3", {
            "px-4 py-2": me === null || other === null,
          })}
        >
          <div className="flex items-center justify-between py-1 -mx-2">
            <div className={classNames("text-lg font-bold px-2")}>
              {t("xp_system.xp_points")}
            </div>
            <div className={classNames("px-2")}>{other?.experiencePoints!}</div>
          </div>
        </div>
      )}
      {me && other && (
        <div
          className={classNames("bg-blue-900", "rounded mb-3", {
            "px-4 py-2": me === null || other === null,
          })}
        >
          <div className="py-2 text-center text-lg font-bold">
            {t("xp_system.xp_points")}
          </div>
          <Row
            left={me?.experiencePoints!}
            right={other?.experiencePoints!}
            center={
              <img src={trophyIcon} width={18} height={18} alt="trophy" />
            }
          />
        </div>
      )}
    </>
  );
};
